import React, { useEffect, useRef, useState } from 'react';
import {
	StyledTextFieldErrorMessage,
	StyledTextFieldLabel,
} from '../../../../../../ui';
import { usePaymentContext } from '../../../../../parking/ui/booking-steps/payment/PaymentContext';
import { adaptMicroformCardNameToCreditCardType } from '../../../../../shared/api/cybersource/adaptMicroformCardNameToCreditCardType';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { StyledMicroformInputContainer } from './StyledMicroformInputContainer';

const NUMBER_CONTAINER_ID = 'number-container';
const CREDIT_CARD_NUMBER_LABEL = 'credit-card-number';

export const MicroformCreditcardNumber = () => {
	const { t } = useTranslation();
	const [showPossibleError, setShowPossibleError] = useState(false);
	const { microformInstance } = usePaymentContext();
	const { setNewCardType, setIsNewCardNumberValid, isNewCardNumberValid } =
		usePaymentContext();

	const numberFieldCreated = useRef(false);

	useEffect(() => {
		if (!microformInstance || numberFieldCreated.current) {
			return undefined;
		}
		const number = microformInstance.createField('number', {
			placeholder: t('payment_form_credit_card_number_placeholder'),
		});

		number.on('change', (data) => {
			setIsNewCardNumberValid(data.valid);
			if (data.card?.length) {
				const cardType = adaptMicroformCardNameToCreditCardType(
					data.card[0].name,
				);
				if (cardType) {
					setNewCardType(cardType);
				} else {
					// eslint-disable-next-line no-console
					console.error('Unknown card type:', data.card[0].name);
				}
			}
		});

		number.on('blur', () => {
			setShowPossibleError(true);
		});

		number.load(`#${NUMBER_CONTAINER_ID}`);
		numberFieldCreated.current = true;

		return () => {
			number.dispose();
		};
	}, [microformInstance]);

	return (
		<>
			<StyledTextFieldLabel id={CREDIT_CARD_NUMBER_LABEL}>
				{t('payment_form_credit_card_number_label')}
			</StyledTextFieldLabel>
			<StyledMicroformInputContainer
				id={NUMBER_CONTAINER_ID}
				aria-labelledby={CREDIT_CARD_NUMBER_LABEL}
				className="form-control"
			/>
			{!isNewCardNumberValid && showPossibleError && (
				<StyledTextFieldErrorMessage role="alert">
					{t('payment_form_credit_card_number_pattern_error')}
				</StyledTextFieldErrorMessage>
			)}
		</>
	);
};
